import { CardContent, CardHeader, Typography } from '@mui/material';
import { LoadingCard } from '../LoadingCard';
import { useNameMapQuery } from '@features/redux/apis/org';
import { EmployeeEffects } from './EmployeeEffects';

export const EmployeeInfoCard = ({ employeeEmail, locationId }: { employeeEmail: string; locationId: number }) => {
    const queryState = useNameMapQuery({});
    const { data, isFetching: loading } = queryState;

    return (
        <>
            <EmployeeEffects queryState={queryState} typeOfData='organization info' />

            <LoadingCard loading={loading} sx={{ width: '100%', height: '100%' }}>
                <CardHeader title='Employee Info' />

                <CardContent>
                    <Typography>
                        Email: <b>{employeeEmail}</b>
                    </Typography>

                    <Typography>
                        Location: <b>{data?.locations[locationId] || `#${locationId}`}</b>
                    </Typography>
                </CardContent>
            </LoadingCard>
        </>
    );
};
